import { useNavigate } from 'react-router';
import { Box, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * ExplorerLaunchPanel
 *
 * Button to navigate to /g-brain/explorer
 */
export function ExplorerLaunchPanel(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
        3D Explorer
      </div>
      <Button
        size="sm"
        className="w-full justify-between"
        onClick={() => {
          navigate('/g-brain/explorer');
        }}
      >
        <div className="flex items-center gap-2">
          <Box className="h-4 w-4" />
          <span>Open Explorer</span>
        </div>
        <ChevronRight className="h-4 w-4" />
      </Button>
      <p className="text-[10px] text-text-tertiary">
        Explore patterns in 3D topology: X=timeline, Y=category, Z=confidence.
      </p>
    </div>
  );
}
